interface CoffeePhotoProps {
  src: string | null;
  alt: string;
  // Tailwind width/height for the tile, e.g. "w-16 h-20" (shelf) or
  // "w-36 h-36 md:w-52 md:h-52" (coffee detail).
  sizeClassName: string;
  // Padding that letterboxes the contained image inside the frame. Scales
  // with the tile: "p-1.5" on the small shelf thumbnail, "p-2 md:p-2.5" on
  // the detail page.
  padClassName?: string;
  // Corner radius of the tile. Defaults to the large-tile radius (Shelf,
  // detail); pass a smaller one on small tiles so the radius stays
  // proportional instead of reading as a squircle (e.g. the search dropdown).
  radiusClassName?: string;
  // Extra classes on the tile wrapper, e.g. "opacity-60" for history cards.
  className?: string;
  testId?: string;
  onError?: () => void;
}

// The framed coffee thumbnail — cream fill, hairline border, soft shadow,
// object-contain image. One source of truth for the frame shared by the shelf
// cards and the coffee detail page, so its radius/fill/shadow can't drift
// across call sites.
export function CoffeePhoto({
  src,
  alt,
  sizeClassName,
  padClassName = 'p-1.5',
  radiusClassName = 'rounded-2xl',
  className = '',
  testId,
  onError,
}: CoffeePhotoProps) {
  return (
    <div
      className={`${sizeClassName} shrink-0 overflow-hidden ${radiusClassName} bg-wolisho-cream border border-wolisho-brown/10 shadow-[0_10px_24px_-14px_rgba(54,17,0,0.45)] ${className}`}
      data-testid={testId}
    >
      <img
        src={src ?? undefined}
        alt={alt}
        className={`w-full h-full object-contain ${padClassName}`}
        onError={onError}
      />
    </div>
  );
}
